import { z } from 'zod';

// Rizikové skóre — Blok 3, Týž. 10-11. Vysvetliteľná heuristika, viď docs/06.
export const riskSignalSchema = z.object({
  type: z.string(),
  points: z.number(),
  label: z.string(),
  detail: z.string(),
});
export type RiskSignal = z.infer<typeof riskSignalSchema>;

export const altmanZScoreSchema = z.object({
  score: z.number(),
  zone: z.enum(['safe', 'grey', 'distress']),
  period: z.number(),
});
export type AltmanZScore = z.infer<typeof altmanZScoreSchema>;

export const riskScoreSchema = z.object({
  companyId: z.string(),
  score: z.number(),
  signals: z.array(riskSignalSchema),
  computedAt: z.string(),
  altmanZScore: altmanZScoreSchema.nullable(),
});
export type RiskScore = z.infer<typeof riskScoreSchema>;

// Bulk scoring — Blok 3, Týž. 12. Zoznam IČO → skóre naraz (B2B segment 1, viď docs/00).
export const bulkRiskScoreResultSchema = z.object({
  ico: z.string(),
  name: z.string().nullable(),
  score: z.number().nullable(),
  signals: z.array(riskSignalSchema),
  error: z.string().nullable(),
});
export type BulkRiskScoreResult = z.infer<typeof bulkRiskScoreResultSchema>;
